<div class="graph-headers row" [class.graph-headers-portrait-override]="displayService.isPortrait">
  <div
    #accountsRef
    #accountTooltip="matTooltip"
    *ngIf="widget?.headers?.Accounts"
    class="column"
    [matTooltip]="getTooltip(accountsRef, widget, 'Accounts')"
    [matTooltipClass]="'mat-tooltip-list'"
    (click)="accountTooltip.toggle()"
  >
    <mat-label>{{ 'graphEmbed.parameters.sessionAccountUid' | translate }}</mat-label>
    <div [ngStyle]="{ 'max-width': headerMaxWidth }">{{ widget?.headers?.Accounts?.join(', ') }}</div>
  </div>
  <div
    #vehicleTypesRef
    *ngIf="widget?.headers?.VehicleTypes"
    class="column"
    [matTooltip]="getTooltip(vehicleTypesRef, widget, 'VehicleTypes')"
    [matTooltipClass]="'mat-tooltip-list'"
  >
    <mat-label>{{ 'graphEmbed.parameters.type' | translate }}</mat-label>
    <div [ngStyle]="{ 'max-width': headerMaxWidth }">{{ widget?.headers?.VehicleTypes?.join(', ') }}</div>
  </div>

  <div
    #dynamicDateRef
    *ngIf="widget?.headers?.DatePeriod"
    class="column"
    [matTooltip]="getTooltip(dynamicDateRef, widget, 'DatePeriod')"
    [matTooltipClass]="'mat-tooltip-list'"
  >
    <mat-label>{{ 'graphEmbed.parameters.dynamicDate' | translate }}</mat-label>
    <div [ngStyle]="{ 'max-width': headerMaxWidth }">{{ widget?.headers?.DatePeriod }}</div>
  </div>
  <div
    #startRef
    *ngIf="widget?.headers?.StartDate"
    class="column"
    [matTooltip]="getTooltip(startRef, widget, 'StartDate')"
    [matTooltipClass]="'mat-tooltip-list'"
  >
    <mat-label>{{ 'graphEmbed.parameters.startDate' | translate }}</mat-label>
    <div [ngStyle]="{ 'max-width': headerMaxWidth }">{{ widget?.headers?.StartDate }}</div>
  </div>
  <div
    #endRef
    *ngIf="widget?.headers?.EndDate"
    class="column"
    [matTooltip]="getTooltip(endRef, widget, 'EndDate')"
    [matTooltipClass]="'mat-tooltip-list'"
  >
    <mat-label>{{ 'graphEmbed.parameters.endDate' | translate }}</mat-label>
    <div [ngStyle]="{ 'max-width': headerMaxWidth }">{{ widget?.headers?.EndDate }}</div>
  </div>
</div>
